import React from 'react';
import {Form as FinalForm, Field} from 'react-final-form';
import {Button, ControlLabel, Form, FormGroup} from "react-bootstrap";
import {FinalFormIManageMatterSelector} from "./iManageMatterSelector";
import {FinalFormIManageWorkspaceFolderSelect} from "./IManageWorkspaceFolderSelector";
import _ from 'lodash';

const changeWorkspaceValue = (form, value, prevValue) => {
  // if the workspace id changed, then change the workspace and clear the folder
  if (_.get(value, 'id') !== _.get(prevValue, 'id')) {
    form.change('workspace', value);
    form.change('folder', undefined);
  }
};

export default ({connectionId, onSave, settings}) => {
  return (
    <FinalForm initialValues={settings} onSubmit={onSave}>
      {({handleSubmit, form, pristine, values, submitting}) =>
        <Form onSubmit={handleSubmit}>
          {false && <pre>{JSON.stringify(values, 0, 2)}</pre>}
          <FormGroup>
            <ControlLabel>iManage Matter</ControlLabel>
            <Field name="workspace"
                   validate={value => (value ? undefined : 'Workspace is required')}
                   component={FinalFormIManageMatterSelector}
                   connectionId={connectionId}
                   value={settings.workspace}
                   onChange={(value) => changeWorkspaceValue(form, value, _.get(values, 'workspace'))}
                   clearable
            />
          </FormGroup>

          {values.workspace &&
            <FormGroup>
              <ControlLabel>Workspace Folder</ControlLabel>
              <Field name="folder"
                     validate={value => ((value && _.size(value) > 0) ? undefined : 'Folder is required')}
                     component={FinalFormIManageWorkspaceFolderSelect}
                     connectionId={connectionId}
                     libraryId={_.get(values, 'workspace.database')}
                     workspaceId={_.get(values, 'workspace.id')}
                     required
                     clearable
              />
            </FormGroup>
          }

          <FormGroup>
            <Button type="submit" bsStyle="primary" disabled={pristine || submitting}>Save</Button>
          </FormGroup>
        </Form>
      }
    </FinalForm>
  );
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/iManage/IManageCaseFolderSettingsForm.jsx